import { AxiosDownloadFile } from 'axios-http';
import { BSLBR } from 'resources/links';

export function downloadFileExcelContract(filters: any, downloadName: string, handleSuccess: any, handleError: any) {
    return AxiosDownloadFile({
        url: BSLBR.getContractExcelFile,
        param: filters,
        downloadName: downloadName,
        onSuccess: handleSuccess,
        onError: handleError
    });
}

export function downloadFileExcelRepair(filters: any, downloadName: string, handleSuccess: any, handleError: any) {
    return AxiosDownloadFile({
        url: BSLBR.getRepairExcelFile,
        param: filters,
        downloadName: downloadName,
        onSuccess: handleSuccess,
        onError: handleError
    });
}

export function downloadFileExcelDelivery(filters: any, downloadName: string, handleSuccess: any, handleError: any) {
    return AxiosDownloadFile({
        url: BSLBR.getDeliveryExcel,
        param: filters,
        downloadName: downloadName,
        onSuccess: handleSuccess,
        onError: handleError
    });
}

export function downloadFileExcelLogIventory(filters: any, downloadName: string, handleSuccess: any, handleError: any) {
    return AxiosDownloadFile({
        url: BSLBR.getLogInventoryExcel,
        param: filters,
        downloadName: downloadName,
        onSuccess: handleSuccess,
        onError: handleError
    });
}

export function downloadFileExcelProductsParts(filters: any, downloadName: string, handleSuccess: any, handleError: any) {
    return AxiosDownloadFile({
        url: BSLBR.getProductsPartsExcel,
        param: filters,
        downloadName: downloadName,
        onSuccess: handleSuccess,
        onError: handleError
    });
}

export function downloadFileExcelInventory(filters: any, downloadName: string, handleSuccess: any, handleError: any) {
    return AxiosDownloadFile({
        url: BSLBR.getInventoryExcelFile,
        param: filters,
        downloadName: downloadName,
        onSuccess: handleSuccess,
        onError: handleError
    });
}

export function downloadFileExcelInventoryPendingItems(filters: any, downloadName: string, handleSuccess: any, handleError: any) {
    return AxiosDownloadFile({
        url: BSLBR.getInventoryExcelFilePendingItems,
        param: filters,
        downloadName: downloadName,
        onSuccess: handleSuccess,
        onError: handleError
    });
}

export function downloadTemplateExcel(filters: any, downloadName: string, handleSuccess: any, handleError: any) {
    return AxiosDownloadFile({
        url: BSLBR.getTemplateExcelFile,
        param: filters,
        downloadName: downloadName,
        onSuccess: handleSuccess,
        onError: handleError
    });
}

export function downloadQuotationFile(filters: any, downloadName: string, handleSuccess: any, handleError: any) {
    return AxiosDownloadFile({
        url: BSLBR.getFileQuotation,
        param: filters,
        downloadName: downloadName,
        onSuccess: handleSuccess,
        onError: handleError
    });
}

export function downloadFileExcelReport(filters: any, downloadName: string, handleSuccess: any, handleError: any) {
    return AxiosDownloadFile({
        url: BSLBR.getReportExcelFile,
        param: filters,
        downloadName: downloadName,
        onSuccess: handleSuccess,
        onError: handleError
    });
}

export function downloadRepairFile(filters: any, downloadName: string, handleSuccess: any, handleError: any) {
    return AxiosDownloadFile({
        url: BSLBR.getRepairFile,
        param: filters,
        downloadName: downloadName,
        onSuccess: handleSuccess,
        onError: handleError
    });
}
